import React from "react";

export default function RouteFallback() {
  return (
    <div
      className="position-absolute top-0 start-0 w-100 h-100 d-flex align-items-center justify-content-center"
      aria-busy="true"
      aria-live="polite"
      aria-label="Loading">
      <div className="spinner-border text-primary" role="status" aria-hidden="true" />
    </div>
  );
}
